module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-ring.0f5eb0a7.png";